// Sentinel profession id shared by the SKU-qualification profession picker and the
// pure grouping engine (helpers/skuQualificationHelpers). Lives in a React-free module
// so the engine can be imported/tested without pulling component/axios/ui.common code.
// (Also breaks the former helpers <-> SelectProfessionExtended circular import.)
export const ANY_PROFESSION_ID = "AnyId";
